import { Pagination as AntPagination } from 'antd';
import { cn } from '@/lib/utils';

interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  className?: string;
  showSizeChanger?: boolean;
  showQuickJumper?: boolean;
  showTotal?: boolean;
  pageSizeOptions?: number[];
}

export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  className,
  showSizeChanger = false,
  showQuickJumper = false,
  showTotal = true,
  pageSizeOptions = [10, 20, 50, 100],
}: PaginationProps) {
  const totalPages = Math.ceil(total / pageSize);

  if (totalPages <= 1 && total <= pageSize) {
    return null;
  }

  return (
    <AntPagination
      current={page}
      pageSize={pageSize}
      total={total}
      onChange={(newPage, newPageSize) => {
        if (newPage !== page) {
          onPageChange(newPage);
        }
        if (newPageSize !== pageSize && onPageSizeChange) {
          onPageSizeChange(newPageSize);
        }
      }}
      showSizeChanger={showSizeChanger}
      showQuickJumper={showQuickJumper}
      showTotal={showTotal ? (total) => `共 ${total} 条` : undefined}
      pageSizeOptions={pageSizeOptions}
      className={cn('flex justify-center', className)}
    />
  );
}
